import React from "react";
import { createFileRoute } from "@tanstack/react-router";
// UI
import { SpringHealthUserCreatePage } from "@pages/spring-health-user-create-page";
import { RouterLoadingComponent } from "@components/router-loading-component";
// data
import { useSpringOnboardingStore } from "src/services/spring-health-onboarding-store";

export const Route = createFileRoute("/spring-health/register/sign-up")({
  component: SpringHealthUserCreatePage,
  pendingComponent: () => <RouterLoadingComponent bgColor="#00382D" />,
  loader: async () => {
    const { clearPayload, payload } = useSpringOnboardingStore.getState();

    /**
     * NOTE: clear storage upon landing on this page (this page has the form on it).
     *
     * We only need the store so that data is persisted between "sign-up" and "enroll" pages!
     */

    const currentData = payload;
    if (currentData) {
      console.log("Data existed in the spring onboarding store! Clearing.");
      clearPayload();
    } else {
      console.log("No data in spring onboarding store - dont clear.");
    }
  },
});
